// extracted by mini-css-extract-plugin
export default {"container":"container---mEuXX","footerContent":"footerContent---P6zdj"};